<mat-form-field appearance="outline">
  <div [formGroup]="freeSearchForm" class="search-wrapper">
    <div class="search-icon-wrapper">
      <app-ui-icon color="var(--grey-3)" name="search" size="md"></app-ui-icon>
    </div>
    <input
      #freeSearchInput
      (focus)="onFreeSearchFocus($event)"
      (keydown.enter)="onFreeSearchEnterHit()"
      autoComplete="off"
      class="test-search-autocomplete-input"
      formControlName="term"
      matInput
      placeholder="Sök efter vårdtjänst, mottagning eller ort"
      type="search"
    >
    @if (isTermFreeSearchNotEmpty()) {
      <div (click)="onFreeSearchClear()" class="close-icon-wrapper">
        <app-ui-icon color="var(--grey-3)" name="close" size="md"></app-ui-icon>
      </div>
    }
  </div>
</mat-form-field>
